<template>
<v-timeline-item
    :color="color"
    small
    v-if="value != null"
>
    <v-row>
    <v-col style="max-width: 200px;">
        <strong>{{value.time_desc}}</strong>
    </v-col>
    <v-col>
        <m-timeline-card
            v-for="(action, index) in value.actions"
            :key="'action_'+index"
            :value="action"
        />

        <div
            v-if="value.warn_multiple"
        >
            <v-icon size="16">mdi-information-outline</v-icon> 
            <span style="font-size: 12px; margin-left: 5px;">May send both a text message and an email &mdash; if this is not what you want, <a href="#">add additional conditions.</a></span>
        </div>
    </v-col>
    </v-row>
</v-timeline-item>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: function() { return null; }
        },
    },

    computed: {
        color() {
            if ( this.value == null ) return 'grey lighten-1';
            if ( this.value.time == '0' ) return 'blue';
            if ( this.value.time.startsWith('-') ) return 'pink';

            return 'green';
        }
    },
}
</script>

<style lang="scss" scoped>
</style>